var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"impersonate-bar"},[_c('div',{staticStyle:{"float":"left"}},[_vm._v(" ID STORE: "+_vm._s(_vm.idStore)+" ")]),_c('div',{staticStyle:{"float":"right"}},[_vm._v(" "+_vm._s(_vm.impersonateMail)+" "),_c('v-btn',{attrs:{"icon":"","color":"pink"},on:{"click":_vm.exorcise}},[_c('v-icon',[_vm._v("mdi-exit-to-app")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }